import {Dispatch} from "react";
import axios from "axios";
import {
    trendingAllTags, trendingCategoriesTags,
    trendingHeadlines,
    // trendingHeadlinesRegion,
    trendingLatestData,
    trendingSelectiveTags, // trendingTagsRegion,
    tvbizzURL
} from "../../../const/urlConst";
import {TrendingItem} from "../../../model/TrendingItem";
import {TrendingCategory} from "../../../model/TrendingCategory";

export const LOAD_TRENDING_HEADLINES_EVENT = 'LOAD_TRENDING_HEADLINES';
export const LOAD_TRENDING_DATA_EVENT = 'LOAD_TRENDING_DATA';
export const LOAD_TRENDING_LOADING_EVENT = 'LOAD_TRENDING_LOADING';
export const LOAD_TRENDING_TAGS_EVENT = 'LOAD_TRENDING_TAGS';
export const SET_TAB_STATE_EVENT = 'SET_TAB_STATE';
export const LOAD_TRENDING_CATEGORIES_TAGS_EVENT = 'LOAD_TRENDING_CATEGORIS_TAGS';

export type LOAD_TRENDING_HEADLINES = typeof LOAD_TRENDING_HEADLINES_EVENT;
export type LOAD_TRENDING_DATA = typeof LOAD_TRENDING_DATA_EVENT;
export type LOAD_TRENDING_LOADING = typeof LOAD_TRENDING_LOADING_EVENT;
export type LOAD_TRENDING_TAGS =  typeof LOAD_TRENDING_TAGS_EVENT;
export type LOAD_TRENDING_CATEGORIES_TAGS = typeof LOAD_TRENDING_CATEGORIES_TAGS_EVENT;
export type SET_TAB_STATE = typeof SET_TAB_STATE_EVENT;

export interface LoadTweetTrendingHeadlines {
  type: LOAD_TRENDING_HEADLINES,
  headlines: TrendingItem[],
}

export interface LoadTweetTrendingCategory {
  type: LOAD_TRENDING_DATA,
  tweets: TrendingItem[],
  tags: TrendingItem[]
  categories: TrendingCategory[],
  loading: boolean,
}

export interface LoadTweetTrendingLoading {
  type: LOAD_TRENDING_LOADING,
  loading: boolean,
}

export interface LoadTagsTrending {
  type: LOAD_TRENDING_TAGS,
  companyTags: TrendingItem[],
  showTags: TrendingItem[],
  peopleTags: TrendingItem[],
}

export interface SetTabState {
  type: SET_TAB_STATE,
  tabState: number,
}

export interface LoadTagsTrendingCategories {
  type: LOAD_TRENDING_CATEGORIES_TAGS,
  categoryTags: TrendingItem[],
}

export const loadingTrendingData = () => {
  return async (dispatch: Dispatch<any>) => {
    dispatch( {
      type: LOAD_TRENDING_LOADING_EVENT,
      loading: true,
    });
  }
}

export const setTabState = (tabState: number) => {
    return async (dispatch: Dispatch<any>)=> {
      dispatch( {
        type: SET_TAB_STATE_EVENT,
        tabState: tabState,
      });
    }
}

export const loadTweetTrendingList = () => {
  return async (dispatch: Dispatch<any>) => {
    const { data } = await axios.get(`${tvbizzURL}${trendingLatestData}`)
    dispatch( {
      type: LOAD_TRENDING_DATA_EVENT,
      tweets: data.topNews,
      tags: data.topTags,
      categories: data.categories,
    });
  }
}

export const loadTweetTrendingHeadlines = () => {
  return async (dispatch: Dispatch<any>) => {
    const { data } = await axios.get(`${tvbizzURL}${trendingHeadlines}`)
    dispatch( {
      type: LOAD_TRENDING_HEADLINES_EVENT,
      headlines: data.topNews,
    });
  }
}

export const loadTrendingTags = () => {
  return async (dispatch: Dispatch<any>) => {
    const { data } = await axios.get(`${tvbizzURL}${trendingAllTags}`)
    dispatch( {
      type: LOAD_TRENDING_TAGS_EVENT,
      companyTags: data.companyTags,
      showTags: data.showTags,
      peopleTags: data.peopleTags,
    });
  }
}

export const loadTrendingTagsCategoriesData = () => {
    return async (dispatch: Dispatch<any>) => {
        const { data } = await axios.get(`${tvbizzURL}${trendingCategoriesTags}`)
        dispatch( {
            type: LOAD_TRENDING_CATEGORIES_TAGS_EVENT,
            categoryTags: data,
        });
    }
}

export const loadSelectiveTrendingTags = () => {
    return async (dispatch: Dispatch<any>) => {
        const { data } = await axios.get(`${tvbizzURL}${trendingSelectiveTags}`)
        dispatch( {
            companyTags: data.companyTags,
            showTags: data.showTags,
            peopleTags: data.peopleTags,
        });
    }
}
